<template>
  <v-card dark class="mx-auto py-3">
    <v-tabs class="d-flex justify-center" v-model="tab" dark background-color="transparent">
      <v-tab>Zeiterfassung</v-tab>
      <v-tab>
        <v-badge color="orange" :content="requestCount" :value="requestCount > 0" overlap>
          <span>Anträge & Wünsche</span>
        </v-badge>
      </v-tab>
      <v-tab>
        <v-badge color="amber darken-3" :content="pendingAbsenceCount" :value="pendingAbsenceCount > 0" overlap>
          <span>Abwesenheit</span>
        </v-badge>
      </v-tab>
      <v-tab>Übersicht</v-tab>
      <v-tab v-if="userService.hasRight('tt_eventsAdmin')">Übersicht Centerleiter</v-tab>
      <v-tab v-if="userService.hasRight('tt_eventsAdmin') && false">Übersicht Techniker</v-tab>
    </v-tabs>

    <v-divider class="mx-4 mb-4" style="border-color: rgba(255, 255, 255, 0.05)"></v-divider>

    <v-tabs-items dark v-model="tab" class="transparent-bg">
      <!-- TAB 1: Zeiterfassung -->
      <v-tab-item>
        <v-row v-if="loading">
          <v-col cols="12">
            <v-progress-linear indeterminate color="primary"></v-progress-linear>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="12">
            <v-expansion-panels class="px-5" v-model="panel">
              <v-expansion-panel v-for="(employee, index) of filteredItems" :key="employee.user + '-panel'">
                <v-expansion-panel-header
                  :class="{
                    'orange--text': submissionState(employee) && submissionState(employee).state === 'submitted',
                    'primary--text': submissionState(employee) && submissionState(employee).state === 'accepted',
                    'red--text': submissionState(employee) && submissionState(employee).state === 'rejected',
                  }">
                  <span :style="submissionState(employee) ? 'font-weight: bold' : ''">
                    {{ employee.fullName + " " + employee.email }}
                  </span>
                  <span
                    v-if="
                      employee &&
                      employee.selfSubmittedTimetrackerMonths &&
                      employee.selfSubmittedTimetrackerMonths.find((month) => month === $moment(datePickerRange[0]).format('YYYY-MM'))
                    ">
                    <v-icon color="primary">mdi-check-decagram</v-icon>
                  </span>
                  <span class="ml-2">
                    <v-chip
                      v-if="submissionState(employee) && submissionState(employee).state !== 'onlyNotes'"
                      :color="
                        submissionState(employee) && submissionState(employee).state === 'rejected'
                          ? 'red'
                          : submissionState(employee) && submissionState(employee).state === 'accepted'
                          ? 'primary'
                          : 'orange'
                      ">
                      {{
                        submissionState(employee) && submissionState(employee).state === "rejected"
                          ? "abgelehnt"
                          : submissionState(employee) && submissionState(employee).state === "accepted"
                          ? "abgeschlossen"
                          : "eingereicht"
                      }}
                    </v-chip>
                  </span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <office-time-tracker-view
                    v-if="index === panel"
                    :studio="selectedStudioSingle"
                    @fetchEntries="trackerViewUpdated"
                    :date-range="datePickerRange"
                    :month="$moment(datePickerRange[0])"
                    :timeEntryView="employee"></office-time-tracker-view>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
          <v-col cols="12" v-if="Object.keys(filteredItems).length === 0">
            <v-alert class="mx-5" type="info">Es wurden keine Einträge gefunden</v-alert>
          </v-col>
        </v-row>
      </v-tab-item>

      <!-- TAB 2: Anträge & Wünsche (NEU) -->
      <v-tab-item>
        <v-container fluid class="px-4">
          <management-requests-view
            ref="requestsView"
            :selectedStudioSingle="selectedStudioSingle"
            @updateCount="updateRequestCount"></management-requests-view>
        </v-container>
      </v-tab-item>

      <!-- TAB 3: Abwesenheit -->
      <v-tab-item>
        <v-row v-if="tab === 2">
          <v-col cols="12">
            <sick-days-view
              :selectedStudioSingle="selectedStudioSingle"
              @fetchEntries="fetchEntries"
              @updateCount="updateRequestCount"></sick-days-view>
          </v-col>
        </v-row>
      </v-tab-item>

      <!-- TAB 4: Übersicht -->
      <v-tab-item>
        <v-row v-if="tab === 3">
          <v-col cols="12">
            <holiday-entries-view :datePickerRange="datePickerRange" :selectedStudioSingle="selectedStudioSingle"></holiday-entries-view>
          </v-col>
        </v-row>
      </v-tab-item>

      <!-- TAB 5: Übersicht Centerleiter -->
      <v-tab-item>
        <v-row v-if="tab === 4">
          <v-col cols="12">
            <holiday-entries-view :datePickerRange="datePickerRange" :studioManager="true"></holiday-entries-view>
          </v-col>
        </v-row>
      </v-tab-item>

      <!-- TAB 6: Übersicht Techniker (Optional) -->
      <v-tab-item>
        <v-row v-if="tab === 5">
          <v-col cols="12">
            <technic-team-overview :datePickerRange="datePickerRange"></technic-team-overview>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import api from "@/api"
import userService from "@/services/userService"
import OfficeTimeTrackerView from "./OfficeTimeTrackerView.vue"
import HolidayEntriesView from "./HolidayEntriesView.vue"
import TechnicTeamOverview from "./TechnicTeamOverview.vue"
import SickDaysView from "./SickDaysView.vue"
import ManagementRequestsView from "./ManagementRequestsView.vue"

export default {
  name: "ManagementTimeTracker",
  components: {
    OfficeTimeTrackerView,
    HolidayEntriesView,
    SickDaysView,
    TechnicTeamOverview,
    ManagementRequestsView,
  },
  props: {
    datePickerRange: {},
    selectedStudioSingle: {
      required: true,
    },
  },
  data() {
    return {
      tab: null,
      userService,
      panel: null,
      loading: false,
      filteredItems: [],
      requestCount: 0,
      pendingAbsenceCount: 0,
    }
  },
  // created() entfernt, da die Watchers mit immediate: true das übernehmen
  methods: {
    submissionState(employee) {
      if (
        employee.timeTrackerMonths &&
        employee.timeTrackerMonths.find((ttm) => ttm.month === this.$moment(this.datePickerRange[0]).format("YYYY-MM"))
      ) {
        return employee.timeTrackerMonths.find((ttm) => ttm.month === this.$moment(this.datePickerRange[0]).format("YYYY-MM"))
      }
      return
    },
    trackerViewUpdated(data) {
      this.fetchEntries(data)
      this.updateRequestCount()
    },
    async fetchEntries(data = null) {
      // WICHTIG: Abbrechen, wenn Daten noch nicht da sind, um Fehler zu vermeiden
      if (!this.selectedStudioSingle || !this.datePickerRange || !this.datePickerRange[0]) {
        return
      }

      this.loading = true
      try {
        this.filteredItems = await api.fetchOfficeTimeEntriesForStudio(this.datePickerRange, this.selectedStudioSingle)
        this.loading = false
      } catch (e) {
        this.filteredItems = []
        this.loading = false
        this.$toast.error("Fehler beim Laden der Einträge")
      }
    },
    async updateRequestCount(count = null) {
      if (!this.selectedStudioSingle) {
        this.requestCount = 0
        this.pendingAbsenceCount = 0
        return
      }
      if (count !== null && typeof count === "number") {
        this.requestCount = count
      }
      try {
        // If count is not passed, fetch the open requests count
        if (count === null || typeof count !== "number") {
          const startDate = this.$moment().startOf("year").format("YYYY-MM-DD")
          const endDate = this.$moment().add(3, "months").endOf("month").format("YYYY-MM-DD")
          const openReqs = await api.fetchManagementRequests(this.selectedStudioSingle, "open", startDate, endDate)
          this.requestCount = openReqs.length
        }

        // Fetch all sick entries to count the pending_cl (waiting for CL) ones
        const sickEntries = await api.fetchSickEntriesManagement(this.selectedStudioSingle)
        this.pendingAbsenceCount = sickEntries.filter((e) => e.status === "pending_cl").length
      } catch (e) {
        console.error("Error updating requests count:", e)
      }
    },
  },
  watch: {
    datePickerRange: {
      handler() {
        // Check ob Range gültig ist
        if (this.datePickerRange && this.datePickerRange[0]) {
          this.fetchEntries()
          this.updateRequestCount()
        }
      },
      deep: true,
      immediate: true, // FIX: Feuert sofort beim Laden, wenn Daten da sind
    },
    selectedStudioSingle: {
      handler() {
        if (this.selectedStudioSingle) {
          this.fetchEntries()
          this.updateRequestCount()
        }
      },
      immediate: true, // FIX: Feuert sofort beim Laden, wenn Daten da sind
    },
  },
}
</script>

<style lang="scss" scoped>
.transparent-bg {
  background: transparent !important;
}
</style>
